import { render, staticRenderFns } from "./alarm-logs-events-modal.vue?vue&type=template&id=c13b9da4&scoped=true&"
import script from "./alarm-logs-events-modal.vue?vue&type=script&lang=js&"
export * from "./alarm-logs-events-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13b9da4",
  null
  
)

export default component.exports